<div ngbDropdown class="dropdown-item" container="body" *transloco="let t; read: 'ime.manufacturing.integrated-master-editor'">
  <button type="button" class="btn btn-link p-0" ngbDropdownToggle>{{t('Copy / Paste')}}</button>
  <div ngbDropdownMenu>
    <button type="button" ngbDropdownItem *ngIf="showCopy" (click)="onCopy.emit();">{{t('Copy')}}</button>
    <button type="button" ngbDropdownItem *ngIf="allowCopyAll" (click)="onCopyAll.emit();">{{t('Copy All')}}</button>
    <ng-container *ngIf="!readonly">
      <button type="button" ngbDropdownItem (click)="onPaste.emit();">{{t('Paste')}}</button>
      <button type="button" ngbDropdownItem (click)="onClipboardPaste.emit();">{{t('Paste from clipboard')}}</button>
    </ng-container>
  </div>
</div>
